export type GrowthEvent = 'landing' | 'share-opened' | 'share-completed' | 'prediction' | 'gauge' | 'north-bank-post' | 'passport-opened' | 'passport-shared' | 'pwa-installed';
export type GrowthSurface = 'now' | 'matches' | 'match' | 'north-bank' | 'club' | 'passport' | 'edition' | 'story' | 'player' | 'other';

function campaign(): string {
  try {
    const value = new URLSearchParams(location.search).get('c') ?? new URLSearchParams(location.search).get('utm_campaign') ?? 'organic';
    return /^[a-z0-9][a-z0-9_-]{0,63}$/i.test(value) ? value.toLowerCase() : 'organic';
  } catch { return 'organic'; }
}

export function currentGrowthSurface(path = typeof location === 'undefined' ? '/' : location.pathname): GrowthSurface {
  const first = path.split('/').filter(Boolean)[0] ?? '';
  if (first === 'match') return 'match';
  if (first === 'north-bank') return 'north-bank';
  if (first === 'edition' || first === 'story' || first === 'player') return first;
  return 'other';
}

export function recordGrowth(event: GrowthEvent, surface: GrowthSurface = currentGrowthSurface()): void {
  if (typeof fetch === 'undefined') return;
  const body = JSON.stringify({ event, surface, campaign: campaign() });
  void fetch('/api/growth/event', {
    method: 'POST', body, keepalive: true, credentials: 'omit',
    headers: { 'content-type': 'application/json' },
  }).catch(() => undefined);
}

export function recordLandingOnce(): void {
  try {
    const key = `coyg_growth_landing:${location.pathname}:${campaign()}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch { /* aggregate measurement is optional */ }
  recordGrowth('landing');
}
